module.exports = __webpack_public_path__ + "static/img/6.50cd34d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/zh/6.png
// module id = qCW3
// module chunks = 0